function getSagaErrorHandler(errorSaga) {
  return function sagaErrorHandler(saga) {
    return function* handledSaga(...args) {
      try {
        yield saga(...args);
      } catch (e) {
        if (process.env.REACT_APP_ENV === 'dev') {
          window.console.log(e);
        }
        if (e?.response?.status === 401) {
          yield window.location.assign('/oao/userauth');
        } else {
          yield errorSaga(e);
        }
      }
    };
  };
}

export default getSagaErrorHandler;
